import { configureStore, history } from './configure-store'
import featureFlags from '../utils/featureFlags'

const initialState = { app: featureFlags.getFeatureFlags() }

const store = configureStore(initialState)

export { store, history }
